import { memo } from 'react'
import { useTranslation } from 'react-i18next'
import { FieldArrayRenderProps } from 'formik'
import upperFirst from 'lodash/upperFirst'
import { Box, Checkbox, RadioBar, RadioBarItem } from '@machobear/design-system'

import { Feature } from '../../types'

interface FeatureItemProps {
  option: Feature
  isLast: boolean
  checked: boolean
  currentType: string
  showTypeOptions: boolean
  typeOptions: string[]
  translationKeyBase: string
  onCheckboxChange: (checked: boolean, option: Feature, arrayHelpers: FieldArrayRenderProps) => void
  onTypeChange: (value: string, option: Feature, arrayHelpers: FieldArrayRenderProps) => void
  arrayHelpers: FieldArrayRenderProps
}

const FeatureItem = memo(
  ({
    option,
    isLast,
    checked,
    currentType,
    showTypeOptions,
    typeOptions,
    translationKeyBase,
    onCheckboxChange,
    onTypeChange,
    arrayHelpers
  }: FeatureItemProps) => {
    const { t } = useTranslation()

    return (
      <Box
        padding="small"
        borderBottom={isLast ? undefined : 'borderNeutralLight'}
        display="flex"
        flexDirection="column"
        gap="small"
        role="option"
      >
        <Checkbox
          id={option.txt_id}
          name={option.txt_id}
          checked={checked}
          label={t(`basic:b.listing.${translationKeyBase}.${option.txt_id}.text`)}
          onChange={(e: React.ChangeEvent<HTMLInputElement>) =>
            onCheckboxChange(e.target.checked, option, arrayHelpers)
          }
        />
        {showTypeOptions && checked && (
          <Box paddingLeft="large">
            <RadioBar
              id={`${option.txt_id}-type`}
              label=""
              aria-label={`Select ${option.name} type`}
              value={currentType}
              onChange={(value: string) => onTypeChange(value, option, arrayHelpers)}
              size="small"
              required
            >
              {typeOptions.map(type => (
                <RadioBarItem key={type} value={type}>
                  {t(`b.listing_features.view.${type}.label`, upperFirst(type))}
                </RadioBarItem>
              ))}
            </RadioBar>
          </Box>
        )}
      </Box>
    )
  }
)

export default FeatureItem
